import API from "@/api/forms2-4/FormLicenseAPI";
import {idUserForApi} from "@/controllers/UserController";
import {spliceUslDataToArray} from "@/controllers/Organizations/Forms(2-4)/Form4AccreditationController";

class Form3LicenseController {
  constructor() {
    this.api = API;
    this.mock = false
  }

  _checkId(id) {
    if (!id)
      throw new Error('id cannot be null');
  }

  /**
   *
   * @param { Number | null | undefined } [orgId]
   * */
  async getData(orgId) {
    try {
      orgId = orgId ?? idUserForApi(orgId);
      this._checkId(orgId);
      const res = this.mock ? {data: []} : await this.api.read(orgId);
      return spliceUslDataToArray(res.data)
    } catch (e) {
      console.error('error getData ' + e.message)
      throw new Error('error getData ' + e.message)
    }
  }

  /**
   *@param { {
   * id: number,
   * sprSpec: {id: number},
   * sprOrgId: number,
   * glsnm: number,
   * gldtb: number,
   * gltxt: number
   * } } data
   * @param { Number | null | undefined } [orgId]
   * */
  async setData(data, orgId) {
    try {
      orgId = orgId ?? idUserForApi(orgId);
      this._checkId(orgId);
      const payload = {...data, orgId: orgId}
      let res;
      if (data.id)
        res = this.mock ? {data: {...payload}} : await this.api.update(payload)
      else
        res = this.mock ? {data: {...payload, id: Math.random()}} : await this.api.create(payload);
      return res.data
    } catch (e) {
      console.error('error setData ' + e.message)
      throw new Error('error setData ' + e.message)
    }
  }

  /**
   *
   * @param { Number} [id]
   * */
  async deleteRow(id) {
    try {
      this._checkId(id);
      const res = this.mock ? {data: {}} : await this.api.delete(id);
      return res.data
    } catch (e) {
      console.error('error deleteRow ' + e.message)
      throw new Error('error deleteRow ' + e.message)
    }
  }
}

export default new Form3LicenseController()